import Image from "next/image";
import styled from "styled-components";
import { device } from "../../../styles/device";
import Date from "../Date";
import { PostSocialLinks } from "./PostSocialLinks";

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  margin-top: 44px;
  margin-bottom: 44px;
  border-radius: 16px;

  img {
    border-radius: 16px;
  }
`;

const PostHeaderMeta = styled.div`
  margin-bottom: 20px;
`;
const PostTitle = styled.h1`
  @media ${device.tablet} {
    font-size: 48px;
    line-height: 1.08349;
    font-weight: 800;
  }

  font-size: 32px;
  line-height: 1.125;
  font-weight: 800;

  margin: 0;
  letter-spacing: -0.05em;
  word-break: break-word;
`;
const PostExcerpt = styled.div`
  font-size: 22px;
  line-height: 27px;
  font-weight: 500;
  letter-spacing: -0.5px;
  margin-bottom: 28px;
`;
const PostEyebrow = styled.div`
  p {
    font-weight: 800;
    margin-top: 0;
    margin-bottom: 2px;
    font-size: 12px;
  }

  &,
  & > * {
    text-transform: uppercase;
    color: #6e6e73;
    line-height: 1.33337;
  }

  time {
    font-weight: 700;
    font-size: 14px;
  }
`;

export default function PostHeader({
  title,
  coverImage,
  date,
  category,
  socialLinks,
}) {
  return (
    <>
      <div className="component-content">
        <PostHeaderMeta>
          <PostEyebrow>
            <p>{category}</p> {/* todo from wordpress category*/}
            <Date dateString={date} />
          </PostEyebrow>
        </PostHeaderMeta>
        <PostTitle>{title}</PostTitle>
        {/*         {excerpt != null &&
          <PostExcerpt dangerouslySetInnerHTML={{ __html: excerpt }}></PostExcerpt>
        } */}
        <PostSocialLinks socialLinks={socialLinks} />
      </div>
      <ImageWrapper>
        {coverImage?.sourceUrl != null && (
          <Image
            src={coverImage?.sourceUrl}
            alt={title}
            width="1080"
            height="540"
            layout="intrinsic"
            objectFit="cover"
          />
        )}
      </ImageWrapper>
    </>
  );
}
